export const styles = {
  container: {
    outerContainer: "flex flex-col items-center h-full z-50",
    innerContainer: "flex flex-col items-center w-full",
  },
  header: {
    outer: "flex items-center bg-primary-1050 w-full",
    inner: "flex items-center justify-around w-full px-8 self-center min-w-[1240px]",
    logo: "flex flex-col items-center",
  },
  backArrow: {
    backArrowEnable: "text-white-100 font-medium text-2xl hover:underline -mt-[2%] p-2 rounded-md",
    backArrowDisable: "cursor-not-allowed opacity-15 -mt-[2%] ",
  },
  closeIcon: "text-primary-1050 font-medium text-2xl hover:underline p-2 rounded-md -mt-[2%] !mr-2",
  progresStep: {
    mainContainer: "flex flex-row items-center justify-center space-x-24 w-full",
    stepLine: "absolute top-4 left-8 w-[160px] h-0.5",
    stepNumberContainer: "relative flex flex-col items-center",
    stepRoundNumber: "h-8 w-8 rounded-full flex items-center justify-center mr-8",
    stepTextContainer:
      "text-sm font-medium text-primary-1050 hover:scale-110 transition-all -ml-6 mt-2",
  },
};
